import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import axiosStrapiInstance from "../axiosStrapi";
import holidayImage from "../assets/HolidayImage.svg";
import GetInTouchFooter from "./GetInTouchFooter";
import { Helmet } from "react-helmet";
import Loader from "./custom/Loader";

const holidayData = [
  {
    month: "April",
    holidays: [
      { date: "11th", name: "EID-UL-FITAR" },
      { date: "26th", name: "AMBEDKAR JAYANTI" },
    ],
  },
  {
    month: "May",
    holidays: [
      { date: "20th", name: "HOLI" },
      { date: "25th", name: "BUDDHA PURNIMA" },
    ],
  },
  { month: "June", holidays: [{ date: "13th", name: "AMBEDKAR JAYANTI" }] },
  { month: "July", holidays: [{ date: "10th", name: "PONGAL" }] },
  { month: "August", holidays: [{ date: "15th", name: "INDEPENDENCE DAY" }] },
  {
    month: "September",
    holidays: [
      { date: "20th", name: "DUSHERRA" },
      { date: "25th", name: "GANDHI JAYANTI" },
    ],
  },
  { month: "October", holidays: [{ date: "6th", name: "RAM NAVMI" }] },
  {
    month: "November",
    holidays: [
      { date: "8th", name: "DIWALI" },
      { date: "14th", name: "CHHATH PUJA" },
    ],
  },
];

const App = () => {
  const [holidays, setHolidays] = useState([]);
  const [loading,setLoading]=useState(false);

  useEffect(() => {
    window.scrollTo(0, 20);
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axiosStrapiInstance.get(
          "/api/holidays?populate=*&sort=month_id:asc"
        );
        const result = response?.data?.data || [];
        setHolidays(result);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data", error);
      }
    };
    fetchData();
  }, []);
  const styles = {
    header: {
      backgroundColor: "white",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      padding: "16px 24px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    headerTitle: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#f87171",
    },
    nav: {
      display: "flex",
      gap: "16px",
    },
    navLink: {
      color: "#4b5563",
      textDecoration: "none",
      cursor: "pointer",
    },
    navLinkHover: {
      color: "#f87171",
    },
    loginButton: {
      backgroundColor: "#f87171",
      color: "white",
      padding: "8px 16px",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
    },
    title: {
      padding: "0px",
      margin: "0px",
      fontSize: window.innerWidth < 450 ? "30px" : "60px",
      lineHeight: "72px",
      paddingBottom: window.innerWidth < 450 ? "0px" : "15px",
      color: "#121212",
    },
    subtitle: {
      // color: "#6b7280",
      padding: "0px",
      margin: "0px",
      paddingBottom: "22px",
    },
    tableContainer: {
      display: "flex",
      justifyContent: "justify-between",
      alignItems: "start",
      gap: "24px",
    },
    tableHead: {
      backgroundColor: "#fee2e2",
    },
    tableCell: {
      padding: "12px",
      border: "1px solid #828282",
      textAlign: "left",
    },
    tableRowEven: {
      backgroundColor: "#f9fafb",
    },
    tableRowOdd: {
      backgroundColor: "white",
    },
    footer: {
      backgroundColor: "#f3f4f6",
      padding: "16px",
      textAlign: "center",
    },
    footerText: {
      fontSize: "14px",
      color: "#6b7280",
    },
    footerLinks: {
      display: "flex",
      justifyContent: "center",
      gap: "16px",
      marginTop: "8px",
    },
    footerLink: {
      color: "#f87171",
      textDecoration: "none",
      cursor: "pointer",
    },
  };

  return (
    <div>
      <Helmet>
        <title>
          Annual Calendar at Mother's Pride - A Year of Learning & Fun
        </title>
        <meta
          name="description"
          content="View the annual academic calendar of Mother's Pride, highlighting key events, festivals, holidays, and important dates throughout the school year."
        />
        <meta name="keywords" content="" />
      </Helmet>
      <div className="px-[4%] 2xl:px-[6%]">
        {/* Main Content */}
        <main
          style={{ overflowX: "hidden !important" }}
          className="font-Lato py-[6%] lg:py-[4%]"
        >
          <h1 style={styles.title} className="ml-[137px] font-Wonderbar">
            List of <span style={{ color: "#D31C4F" }}>Holidays</span>
          </h1>
          <h2
            style={styles.subtitle}
            className="font-bold text-lg sm:text-xl ml-[137px]"
          >
            LIST OF HOLIDAYS - (APRIL 2025 - MARCH 2026)
          </h2>
          <div style={styles.tableContainer} className="sm:gap-[3rem]">
            {/* Holiday Table */}
            <table
              style={{
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
                border: "1px solid #828282",
                overflow: "hidden",
              }}
              className="w-[100%] lg:w-[65%] max-w-[1000px] border-collapse bg-white "
            >
              <thead style={styles.tableHead}>
                <tr>
                  <th style={styles.tableCell}>Month</th>
                  <th style={styles.tableCell}>Date</th>
                  <th style={styles.tableCell}>Holiday Name</th>
                </tr>
              </thead>
              {loading ? (<div className="w-full min-w-[320px] lg:min-w-[600px] flex items-center justify-center min-h-[400px]">
                <Loader/>
              </div>):(
                 <tbody>
                {holidays.map(({ month, holidayItems }) =>
                  holidayItems.map((holiday, index) => (
                    <tr key={index} className="font-medium">
                      {index === 0 && (
                        <td
                          className=" sm:text-base text-sm px-3 text-left border border-[#828282]"
                          rowSpan={holidayItems?.length}
                        >
                          {month}
                        </td>
                      )}
                      <td style={styles.tableCell}>{holiday.date}</td>
                      <td style={styles.tableCell} className="text-[#D31C4F]">
                        {holiday.name}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              )}
             
            </table>

            {/* Illustration */}
            <img
              src={holidayImage}
              alt="Holiday Illustration"
              className="sm:relative absolute top-[10%] right-[-10%] sm:right-[20px] h-[150px] sm:block hidden sm:w-[250px] lg:w-[400px] ml-[20px] sm:h-[570px]"
            />
          </div>
        </main>
        <GetInTouchFooter marginX={"0%"} />
        <Footer marginX={"0%"} />
      </div>
    </div>
  );
};

export default App;
